import useViewportDimensions from "hooks/viewport-dimensions";
import { useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { accountSiteList } from "store/appSelectors";
import ProfileCard from "widgets/cards/profile";
import UserSitesForm, { UserSitesFormType } from "widgets/forms/users/sites";
import { SearchInput } from "widgets/shared/inputs/search";
import { useTranslation } from "react-i18next";

// Define the props for the Role component
interface SitesProps {
  classes?: string[];
  onSubmit?: (formData: UserSitesFormType) => void;
}

const Sites: React.FC<SitesProps> = ({ classes = [], onSubmit }) => {
  const { t } = useTranslation();
  const { dimensions, getControlHeight } = useViewportDimensions();
  const sites = useSelector(accountSiteList, shallowEqual);
  const [filter, setFilter] = useState("");

  const filteredSites = sites.filter((site) =>
    site.name.toLowerCase().includes(filter.toLowerCase())
  );

  const handleSubmit = (formData: UserSitesFormType) => {
    if (onSubmit) {
      onSubmit(formData);
    }
  };

  const calcHeight =
    dimensions.contentHeight - getControlHeight("user-top-grid") - 8;

  return (
    <ProfileCard
      title={t("dialog.user.sites.title")}
      description={t("dialog.user.sites.description")}
      extra={`bg-white min-h-96`}
      style={{ height: `${calcHeight}px` }}
      topRight={
        <div className="flex flex-col  gap-2">
          <SearchInput
            onChange={(filters) => {
              setFilter(filters);
            }}
            type="text"
            value={filter}
            sizes="md"
          />
        </div>
      }
    >
      <div className="w-full overflow-auto pb-2 md:-mt-4">
        <UserSitesForm
          sites={filteredSites}
          values={{
            classes: classes?.includes("All")
              ? sites.map((item) => item.id)
              : classes,
          }}
          loading={classes?.includes("All")}
          submit={handleSubmit}
          onClose={() => {}}
        />
      </div>
    </ProfileCard>
  );
};

export default Sites;
